"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemberSystemApi = void 0;
var tslib_1 = require("tslib");
/* eslint-disable */
/* 此代码由工具自动生成,不要直接修改,以免下次生成会丢失 */
var di_1 = tslib_1.__importDefault(require("@jsmodules/di"));
var getApi_1 = tslib_1.__importDefault(require("../../getApi"));
var MemberSystemApi = /** @class */ (function () {
    function MemberSystemApi() {
        this.http = getApi_1.default('api_v1');
    }
    /**
     * 查询会员体系,添加会员体系
     * @method GET 查询会员体系
     * @method POST 添加会员体系
     *
     */
    MemberSystemApi.prototype.MemberSystem = function () {
        return this.http
            .url("/api/MemberSystem")
            .addSecurityHeaders()
            .support('GET', 'POST');
    };
    /**
     * 获取指定Id会员体系,修改会员体系
     * @method GET 获取指定Id会员体系
     * @method PUT 修改会员体系
     *
     * @params id 无说明
     */
    MemberSystemApi.prototype.MemberSystemById = function (id) {
        return this.http
            .url("/api/MemberSystem/" + id)
            .addSecurityHeaders()
            .support('GET', 'PUT');
    };
    MemberSystemApi.diOptions = di_1.default.options({
        name: "MemberSystemApi",
        scope: "Singleton"
    });
    return MemberSystemApi;
}());
exports.MemberSystemApi = MemberSystemApi;
exports.default = MemberSystemApi;
